import { render } from "./data_usage.vue?vue&type=template&id=58bb77ab"
import script from "./data_usage.vue?vue&type=script&lang=js"
export * from "./data_usage.vue?vue&type=script&lang=js"

import "./data_usage.vue?vue&type=style&index=0&id=58bb77ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__